/**
 * Errors - app error messages
 */
const Errors = {
  GENERIC_SERVER_ERROR:
    'We are currently experiencing an issue with our servers.  Please try again later or contact customers@linearb.io.',
  DUPLICATE_KEY_ERROR:
    'This user email and/or organization has already requested an assessment. Please contact customers@linearb.io if you have any questions.',

  Signup: {
    NAME_IS_EMPTY: "Name can't be empty",
    EMAIL_IS_EMPTY: "Email can't be empty",
    EMAIL_INVALID: 'Please enter a valid Email address',
    ORGANIZATION_IS_EMPTY: "Organization can't be empty"
  },

  RepoList: {
    NO_REPOS_TITLE: 'No Repositories Selected',
    NO_REPOS_SELECTED_ERROR: 'Please select at least one repository to analyze'
  },

  JiraReports: {
    NO_FILE_FOUND:
      'Please wait while we are processing your reports. This might take several minutes.'
  },

  ONBOARDING: {
    DUPLICATE_ORGANIZATION_NAME: 'Company name already in use',
    BAD_ORGANIZATION_NAME:
      'Company name must be an alphanumeric string with commas, dots and hyphens',
    GENERAL_ERROR: 'Something went wrong, please try again later'
  },
  SETTINGS: {
    JIRA: {
      BAD_REGEX:
        'Regular expression is invalid or does not match any iterations'
    }
  },
  INTEGRATIONS: {
    BAD_NAME: 'Use only letters and numbers for the integration name',
    EMPTY_NAME: 'Please enter a name for this integration',
    GENERAL_ERROR: 'Something went wrong, please try again later'
  }
};

export default Errors;
